import { sessionCheckClient } from "../auth/AuthenticatedAxios"
import { API } from "./constants"

export type TCompanyData = { color?: string; logo?: { s3Key?: string } }

// öffentliche Endpunkte (auch vor der Anmeldung): Farbe und Logo; Client ohne 401-Interceptor
export const getCompanyData = (): Promise<TCompanyData> => sessionCheckClient.get(API + "/global-settings/color-and-logo").then((res) => res.data)

export const getLogo = async () => {
    const response = await sessionCheckClient.get(`${API}/global-settings/logo`, {
        responseType: "blob",
    })
    return URL.createObjectURL(response.data)
}
